import { useTranslation } from 'react-i18next';
import { Button, DropdownMenu } from '@hotjar/hotsauce';
import { QuestionTypes } from '../../../../../domain/Surveys/Questions/QuestionTypes';

export interface AddQuestionButtonProps {
  onSelect: (questionType: QuestionTypes | 'yes-no') => void;
  className?: string;
  title?: string;
}

export const AddQuestionButton = (props: AddQuestionButtonProps): JSX.Element => {
  const { onSelect, className, title } = props;
  const { t } = useTranslation('feedback');

  return (
    <DropdownMenu
      className={className}
      trigger={
        <Button kind="ghost" icon="plus" title={title}>
          {t('wizard.section.questions.add-question.title')}
        </Button>
      }
    >
      <DropdownMenu.Item icon="like" onClick={() => onSelect(QuestionTypes.REACTION)}>
        {t('wizard.section.questions.add-question.reaction')}
      </DropdownMenu.Item>
      <DropdownMenu.Item
        icon="text_field_short"
        onClick={() => onSelect(QuestionTypes.SINGLE_OPEN_ENDED_SINGLE_LINE)}
      >
        {t('wizard.section.questions.add-question.short-text-answer')}
      </DropdownMenu.Item>
      <DropdownMenu.Item
        icon="text_field_tall"
        onClick={() => onSelect(QuestionTypes.SINGLE_OPEN_ENDED_MULTI_LINE)}
      >
        {t('wizard.section.questions.add-question.long-text-answer')}
      </DropdownMenu.Item>
      <DropdownMenu.Item icon="email" onClick={() => onSelect(QuestionTypes.EMAIL)}>
        {t('wizard.section.questions.add-question.email')}
      </DropdownMenu.Item>
      <DropdownMenu.Item icon="radio_button" onClick={() => onSelect('yes-no')}>
        {t('wizard.section.questions.add-question.yes-no')}
      </DropdownMenu.Item>
      <DropdownMenu.Item
        icon="radio_button"
        onClick={() => onSelect(QuestionTypes.SINGLE_CLOSE_ENDED)}
      >
        {t('wizard.section.questions.add-question.radio-options')}
      </DropdownMenu.Item>
      <DropdownMenu.Item
        icon="checkbox"
        onClick={() => onSelect(QuestionTypes.MULTIPLE_CLOSE_ENDED)}
      >
        {t('wizard.section.questions.add-question.checkbox-options')}
      </DropdownMenu.Item>
      <DropdownMenu.Item icon="rating_scale" onClick={() => onSelect(QuestionTypes.RATING_SCALE_5)}>
        {t('wizard.section.questions.add-question.1-5-rating-scale')}
      </DropdownMenu.Item>
      <DropdownMenu.Item icon="rating_scale" onClick={() => onSelect(QuestionTypes.RATING_SCALE_7)}>
        {t('wizard.section.questions.add-question.1-7-rating-scale')}
      </DropdownMenu.Item>
      <DropdownMenu.Item icon="nps" onClick={() => onSelect(QuestionTypes.NET_PROMOTER_SCORE)}>
        {t('wizard.section.questions.add-question.nps')}
      </DropdownMenu.Item>
      <DropdownMenu.Item icon="text" onClick={() => onSelect(QuestionTypes.TITLE_AND_DESCRIPTION)}>
        {t('wizard.section.questions.add-question.statement')}
      </DropdownMenu.Item>
    </DropdownMenu>
  );
};

export const AddQuestionButtonWithIndex = (props: {
  onSelect: (questionType: QuestionTypes | 'yes-no', index: number) => void;
  className?: string;
  index: number;
}): JSX.Element => {
  const { index, className, onSelect } = props;
  const { t } = useTranslation('feedback');

  return (
    <AddQuestionButton
      className={className}
      onSelect={(questionType) => onSelect(questionType, index)}
      title={t('wizard.section.questions.add-question.description', { position: index + 1 })}
    />
  );
};
